import {TitleAppBar} from "~/ui/AppBar/TitleAppBar";
import {Tab, Tabs} from "@mui/material";
import {useRouteMatch} from "react-router-dom";
import {VesselCallDetail} from "~/apps/packages/vessel-calls/components/VesselCallDetail";
import {useVesselCall} from "~/apps/packages/vessel-calls/hooks";
import {useState} from "react";
import SwipeableViews from "react-swipeable-views";
import {Box} from "@mui/system";
import {VesselCallMap} from "~/apps/packages/vessel-calls/components/VesselCallDetail/VesselCallMap";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";
import {VesselCallLogs} from "~/apps/packages/vessel-calls/components/VesselCallDetail/VesselCallLogs";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";


export const DetailPage = () => {
    const match = useRouteMatch<{id: string}>();
    const {data, loading} = useVesselCall({id: match.params.id});
    const [currentTab, setCurrentTab] = useState<number>(0);
    const appBarHeight = 104;

    const handleTabChange = (_, value) => {
        setCurrentTab(value);
    }

    const handleSwipeableViewIndexChange = (value) => {
        setCurrentTab(value);
    }

    return (
        <>
            <TitleAppBar title="Судозаход">
                <Tabs value={currentTab} onChange={handleTabChange}>
                    <Tab label="Информация"/>
                    <Tab label="Журнал"/>
                    <Tab label="Карта"/>
                </Tabs>
            </TitleAppBar>
            <AbsoluteContainer top={appBarHeight} disableGutters>
                <LoadingBox loading={loading}>
                    {!loading && /*при вычислении высоты во время загрузки, после отображается неверно*/ (
                        <SwipeableViews
                            index={currentTab}
                            onChangeIndex={handleSwipeableViewIndexChange}
                            enableMouseEvents={true}
                            animateHeight={true}
                        >
                            <Box height={window.innerHeight - appBarHeight} paddingX={2}  overflow="auto">
                                <VesselCallDetail vesselCall={data}/>
                            </Box>
                            <Box height={window.innerHeight - appBarHeight} paddingX={2} overflow="auto" display="flex" flexDirection="column">
                                <VesselCallLogs vesselCall={data}/>
                            </Box>
                            <Box height={window.innerHeight - appBarHeight} display="flex" flexDirection="column">
                                <VesselCallMap vesselCall={data}/>
                            </Box>
                        </SwipeableViews>
                    )}
                </LoadingBox>
            </AbsoluteContainer>
        </>
    )
}